import { faXmark } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";

import * as Yup from "yup";
import { IBondsDebentureForm } from "../../../../config/interfaces";
import FASvgIcon from "../../../FASvgIcon";

import { Formik } from "formik";
import { cloneDeep } from "lodash";
import { CGBondsAndDebentureForm } from "..";
import {
  BondsAndDebentureFormInitValues,
  BondsAndDebentureFormSchema
} from "../../../../pages/itr-filing/efiling.config";
import { useAppSelector } from "../../../../redux/Store";
import { ITRFilingSelector } from "../../../../redux/slice/ITRFilingSlice";
import ScrollToFirstError from "../../../ScrollToFirstError";

type Props = {
  showCanvas: boolean;
  formValues: IBondsDebentureForm | null;
  handleCloseBtnPress: (IBondsDebentureForm: IBondsDebentureForm | null) => void;
};

const CGBondsAndDebentureDetailsForm: React.FC<Props> = (props: Props) => {
  const { showCanvas, handleCloseBtnPress, formValues } = props;

  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  const [initFormValues, setInitFormValues] = useState<IBondsDebentureForm>(
    BondsAndDebentureFormInitValues
  );

  useEffect(() => {
    if (showCanvas && formValues) {
      setInitFormValues(() => cloneDeep(formValues));
    } else {
      setInitFormValues(() => cloneDeep(BondsAndDebentureFormInitValues));
    }
  }, [showCanvas, formValues]);

  return (
    <>
      <Offcanvas show={showCanvas} placement="end" backdrop={true}>
        <Formik
          enableReinitialize={true}
          initialValues={initFormValues}
          validationSchema={Yup.object().shape({ ...BondsAndDebentureFormSchema })}
          onSubmit={(values) => {
            let _values = { ...values };
            handleCloseBtnPress(_values);
          }}
        >
          {({ handleSubmit, submitCount, isValid, errors, validateForm }) => (
            <>
              <ScrollToFirstError submitCount={submitCount} isValid={isValid} errors={errors} />

              <Offcanvas.Header>
                <Offcanvas.Title>Add/Edit Bonds and Debenture Details</Offcanvas.Title>
                <Button
                  variant="primary"
                  className="icon-only hide-offcanvas"
                  onClick={() => handleCloseBtnPress(null)}
                >
                  <FASvgIcon icon={faXmark} />
                </Button>
              </Offcanvas.Header>

              <Offcanvas.Body>
                <CGBondsAndDebentureForm />
              </Offcanvas.Body>

              <div className="offcanvas-btns">
                {!isFilingReadOnly ? (
                  <Button
                    variant="outline-white"
                    size="sm"
                    onClick={async (event) => {
                      event.preventDefault();
                      await validateForm();
                      handleSubmit();
                    }}
                  >
                    Save and Close
                  </Button>
                ) : (
                  <Button
                    variant="outline-white"
                    size="sm"
                    onClick={() => handleCloseBtnPress(null)}
                  >
                    Close
                  </Button>
                )}
              </div>
            </>
          )}
        </Formik>
      </Offcanvas>
    </>
  );
};

export default CGBondsAndDebentureDetailsForm;
